module.exports = __webpack_public_path__ + "media/images/avatar/blue-6641ee9211a629b511444f2546ed6262.svg";